import React, { Component, Fragment } from 'react';
import { withStyles } from "@material-ui/styles";
import { styles } from "../devotees/DevoteeContainer.styles";
import { theme } from "../../layout/Layout.theme";
import ParticipationWeekly from './Participation.weekly';

class ParticipationContainer extends Component {

  render () {
    // const { classes } = this.props;
    return (
      <Fragment>
        <ParticipationWeekly />
      </Fragment>
    );
  }
}

export default (
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(ParticipationContainer));
